export const GET_LOGBOOK_BUILDING_REQUEST = "GET_LOGBOOK_BUILDING_REQUEST";
export const GET_LOGBOOK_BUILDING_SUCCESS = "GET_LOGBOOK_BUILDING_SUCCESS";
export const GET_LOGBOOK_BUILDING_FAILURE = "GET_LOGBOOK_BUILDING_FAILURE";

export const ADD_LOGBOOK_BUILDING_REQUEST = "ADD_LOGBOOK_BUILDING_REQUEST";
export const ADD_LOGBOOK_BUILDING_SUCCESS = "ADD_LOGBOOK_BUILDING_SUCCESS";
export const ADD_LOGBOOK_BUILDING_FAILURE = "ADD_LOGBOOK_BUILDING_FAILURE";

export const EDIT_LOGBOOK_BUILDING_REQUEST = "EDIT_LOGBOOK_BUILDING_REQUEST";
export const EDIT_LOGBOOK_BUILDING_SUCCESS = "EDIT_LOGBOOK_BUILDING_SUCCESS";
export const EDIT_LOGBOOK_BUILDING_FAILURE = "EDIT_LOGBOOK_BUILDING_FAILURE";

export const DELETE_LOGBOOK_BUILDING_REQUEST = "DELETE_LOGBOOK_BUILDING_REQUEST";
export const DELETE_LOGBOOK_BUILDING_SUCCESS = "DELETE_LOGBOOK_BUILDING_SUCCESS";
export const DELETE_LOGBOOK_BUILDING_FAILURE = "DELETE_LOGBOOK_BUILDING_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST"
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS"
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE"

export const GET_LOGBOOK_BUILDING_BY_ID_REQUEST = "GEBUILDING_BY_ID_REQUEST"
export const GET_LOGBOOK_BUILDING_BY_ID_SUCCESS = "GEBUILDING_BY_ID_SUCCESS"
export const GET_LOGBOOK_BUILDING_BY_ID_FAILURE = "GEBUILDING_BY_ID_FAILURE"

export const EXPORT_LOGBOOK_BUILDING_TABLE_REQUEST = "EXPORT_LOGBOOK_BUILDING_TABLE_REQUEST"
export const EXPORT_LOGBOOK_BUILDING_TABLE_SUCCESS = "EXPORT_LOGBOOK_BUILDING_TABLE_SUCCESS"
export const EXPORT_LOGBOOK_BUILDING_TABLE_FAILURE = "EXPORT_LOGBOOK_BUILDING_TABLE_FAILURE"

export const GET_ALL_LOGBOOK_BUILDING_LOG_REQUEST = "GET_ALL_LOGBOOK_BUILDING_LOG_REQUEST";
export const GET_ALL_LOGBOOK_BUILDING_LOG_SUCCESS = "GET_ALL_LOGBOOK_BUILDING_LOG_SUCCESS";
export const GET_ALL_LOGBOOK_BUILDING_LOG_FAILURE = "GET_ALL_LOGBOOK_BUILDING_LOG_FAILURE";

export const RESTORE_LOGBOOK_BUILDING_LOG_REQUEST = "RESTORE_LOGBOOK_BUILDING_LOG_REQUEST";
export const RESTORE_LOGBOOK_BUILDING_LOG_SUCCESS = "RESTORE_LOGBOOK_BUILDING_LOG_SUCCESS";
export const RESTORE_LOGBOOK_BUILDING_LOG_FAILURE = "RESTORE_LOGBOOK_BUILDING_LOG_FAILURE";

export const DELETE_LOGBOOK_BUILDING_LOG_REQUEST = "DELETE_LOGBOOK_BUILDING_LOG_REQUEST";
export const DELETE_LOGBOOK_BUILDING_LOG_SUCCESS = "DELETE_LOGBOOK_BUILDING_LOG_SUCCESS";
export const DELETE_LOGBOOK_BUILDING_LOG_FAILURE = "DELETE_LOGBOOK_BUILDING_LOG_FAILURE";

export const UPDATE_LOGBOOK_BUILDING_ENTITY_PARAMS_SUCCESS ="UPDATE_LOGBOOK_BUILDING_ENTITY_PARAMS_SUCCESS";
export const UPDATE_LOGBOOK_BUILDING_ENTITY_PARAMS_FAILURE ="UPDATE_LOGBOOK_BUILDING_ENTITY_PARAMS_FAILURE";
